<template>
  <b-col lg="12" v-if="formId">
    <processForm :form-id="formId"></processForm>
  </b-col>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import processForm from '@/views/forms/processForm'

export default {
  components: {
    processForm
  },
  data () {
    return {
      formId: null
    }
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  created () {
    let vm = this
    Vue.axios.get('/form_docs/' + this.$route.params.docId, { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        if (res.status === 200) {
          this.formId = res.data.form_doc.first_form_id
        }
      })
      .catch(error => {
        if (error.status === 404) {
          Vue.toasted.show(this.$t('COMMON.MSG_FORM_REQ'), { icon: 'chain-broken', type: 'error' })
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_FETCH_ERR'), { icon: 'chain-broken', type: 'error' })
        }
      })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/docs/processDoc.vue